import React from "react";
import PropTypes from "prop-types";
import "../assets/stylesheets/InputText.scss";
import InputMask from "react-input-mask";

export default class InputText extends React.Component {

    static propTypes = {
        onKeyPress: PropTypes.func,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        autoFocus: PropTypes.bool,
        name: PropTypes.string,
        type: PropTypes.string,
        mask: PropTypes.string,
        pattern: PropTypes.string,
        readonly: PropTypes.bool,
        style: PropTypes.object
    };

    static defaultProps = {
        onBlur: () => {
        },
        onKeyPress: () => {

        },
        onFocus: () => {
        },
        autoFocus: false,
        readonly: false,
        type: "text",
        pattern: "",
        style: {}
    };

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
    }

    handleChange = (e) => {
        this.setState({value: e.target.value});
        if(this.props.onChange) {
            this.props.onChange(e);
        }
    };

    handleFocus = (e) => {
        this.props.onFocus(e);
    };

    handleBlur = (e) => {
        this.props.onBlur(e);
    };

    handleKeyPress = (e) => {
        this.props.onKeyPress(e);
    }

    componentDidMount() {
        if (this.props.autoFocus === true) {
            this.input.focus();
        }
    }

    componentWillReceiveProps(props) {
        this.setState({value: props.value ? props.value :  ""});

        if (props.autoFocus === true) {
            this.input.focus();
        }
    }

    render() {
        const {
            type = "text",
            placeholder = 'campo',
            classDef = '',
            name,
            mask = null,
            disabled = false,
            readonly = false,
            style= {}
        } = this.props;

        const disabledProp = disabled === true ? "disabled" : '';

        return (
            <div className='InputText'>
                {!(mask && mask.length > 0) ?
                    <input
                        name={name}
                        type={type}
                        value={this.state.value}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        onKeyPress={this.handleKeyPress}
                        className={classDef}
                        placeholder={placeholder}
                        disabled={disabledProp}
                        readOnly={readonly}
                        style={style}
                        ref={ input => this.input = input } />
                    :
                    <InputMask
                        name={name}
                        type={type}
                        value={this.state.value}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        className={classDef}
                        placeholder={placeholder}
                        mask={mask}
                        maskChar=" "
                        style={style}
                    />
                }
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/InputText.js